//  Copyright (c) 2021 Comsearch, Inc., All rights reserved

import React, { useCallback } from 'react'
import { bool, func, string } from 'prop-types'
import { MenuOptionWrapper } from './styles'

const MenuOption = props => {
  const {
    enabled,
    icon,
    id,
    label,
    modalTemplate,
    setModalTemplate,
  } = props

  const handleClick = useCallback(() => (
    enabled && setModalTemplate(modalTemplate)
  ), [enabled])

  return (
    <MenuOptionWrapper
      className={enabled ? '' : 'disabled'}
      id={id}
      onClick={handleClick}>
      <img
        alt={`${label} icon`}
        src={icon} />
      <span>
        {label}
      </span>
    </MenuOptionWrapper>
  )
}

MenuOption.propTypes = {
  enabled: bool.isRequired,
  icon: string.isRequired,
  id: string.isRequired,
  label: string.isRequired,
  modalTemplate: string.isRequired,
  setModalTemplate: func.isRequired,
}

export default MenuOption
